import Vue from 'vue'

/**
 *  A place to store data that is used across
 */
export default (Vue as any).extend({
  data() {
    return {
      allLayouts: { type: Array },
      currentLayoutIndex: 0,
      mediaQueryListeners: []
    }
  },
  computed: {
    allItemsInLayout() {
      if (this.currentLayout) {
        const columnItems = this.currentLayout.columns.reduce((acc, cur) => {
          return acc.concat(cur.items)
        }, [])
        return this.currentLayout.headerItems
          .concat(this.currentLayout.footerItems)
          .concat(columnItems)
      }
      return []
    },
    currentBreakpointConfig() {
      return this.allLayouts.length > 0 ? this.allLayouts[this.currentLayoutIndex] : null
    },
    currentBreakpoint() {
      return this.currentBreakpointConfig ? this.currentBreakpointConfig.breakpoint : null
    },
    currentLayout() {
      return this.currentBreakpointConfig ? this.currentBreakpointConfig.layout : null
    },
    // in mobile layout, if 'showDetails' item is added, everything below it is initially hidden
    // from view. This provides an array of the layout items that are below 'showDetails'
    slotNamesAfterShowDetails() {
      if (this.currentLayout) {
        const items =
          this.currentLayout.columns.length === 1 ? this.currentLayout.columns[0].items : []
        if (items.length > 0 && items.indexOf('showDetails') > 0) {
          return items.slice(items.indexOf('showDetails') + 1)
        }
      }
      return []
    }
  },
  methods: {
    removeListeners() {
      this.mediaQueryListeners.forEach((item) => {
        if (item['mediaQueryList']) {
          item['mediaQueryList'].removeListener(item['mediaQueryListener'])
        }
      })
      this.mediaQueryListeners = []
    },
    setLayoutsConfig(layoutsConfig) {
      this.allLayouts = layoutsConfig
      this.setupLayout()
    },
    setupLayout() {
      // make sure any existing are cleared out
      this.removeListeners()
      this.currentLayoutIndex = 0
      for (let i = 1; i < this.allLayouts.length; i++) {
        const breakpointLayout = this.allLayouts[i]
        const mediaQueryList = window.matchMedia(`(min-width: ${breakpointLayout.breakpoint}px)`)
        const mediaQueryListener = (e) => {
          const layoutIndex = e.matches ? i : i - 1
          this.currentLayoutIndex = layoutIndex
        }
        mediaQueryList.addListener(mediaQueryListener)
        this.mediaQueryListeners.push({ mediaQueryList, mediaQueryListener })
        if (mediaQueryList.matches) {
          this.currentLayoutIndex = i
        }
      }
    }
  },
  beforeDestroy() {
    this.removeListeners()
  }
})
